import React from "react";
import { useNavigate } from "react-router-dom";
import NotFoundLoop from "../assets/404-looping-gray.gif";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const redirectToProfile = () => {
    navigate("/");
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <img
          src={NotFoundLoop}
          className="bg-gray-100"
          alt="404 Error! Page Not Found"
        />
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          Page Not Found
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Looks like you followed the wrong path.
        </p>
        <p className="text-gray-500">
          Don't worry, let's get you back{" "}
          <a
            href="/"
            className="text-blue-500 underline cursor-pointer"
            onClick={redirectToProfile}
          >
            Home
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
